import React, { useState, useEffect } from "react";
import ReactTable from "react-table-6";
import { numberToFormat } from "../../Utils";

const ROWS = [
  { label: "1. Préparation du chantier :" },
  { label: "1.1. Inspections Communes avec les entreprises" },
  { label: "1.2. Harmonisation des P.P.S.P.S./Mise à jour du P.G.C" },
  { label: "1.3. Tenue Registre Journal" },
  { label: "2. Travaux :" },
  { label: "2.1. Visites de chantier" },
  { label: "2.2. Réunions de C.I.S.S.C.T" },
  { label: "2.3. Participation au rendez-vous de chantier" },
  { label: "3. Réception des travaux :" },
  { label: "3.1. Récolement des pièces liées au D.I.U.O" },
  { label: "3.2. Mise à jour du D.I.U.O.final" },
  { label: "3.3. Diffusion du P.G.C. et du D.I.U.O" },
  { label: "TOTAL HEURES :" },
];

const GROUP_INDICES = new Set([0, 4, 8, 12]);
const ZERO_HOURS = [0, 0, 0, 0, 0, 0, 0, 0, 0];

function heureIndex(rowIndex) {
  if (rowIndex < 4) return rowIndex - 1;
  if (rowIndex < 8) return rowIndex - 2;
  return rowIndex - 3;
}

const ContractAmendmentDevisReaTable = ({ tauxh, initialNbrHeures, onHoursChange }) => {
  const [nbrHeures, setNbrHeures] = useState(
    initialNbrHeures && initialNbrHeures.length === 9 ? initialNbrHeures : ZERO_HOURS
  );

  useEffect(() => {
    const next = initialNbrHeures && initialNbrHeures.length === 9
      ? initialNbrHeures
      : ZERO_HOURS;
    setNbrHeures(prev => (prev === next ? prev : next));
  }, [initialNbrHeures]);

  const phase1 = nbrHeures.slice(0, 3).reduce((t, h) => t + Number(h), 0);
  const phase2 = nbrHeures.slice(3, 6).reduce((t, h) => t + Number(h), 0);
  const phase3 = nbrHeures.slice(6, 9).reduce((t, h) => t + Number(h), 0);
  const totalAll = phase1 + phase2 + phase3;

  useEffect(() => {
    if (onHoursChange) onHoursChange({ total: totalAll, nbrHeures });
  }, [totalAll, nbrHeures]);

  const getGroupValue = (rowIndex) => {
    if (rowIndex === 0) return phase1;
    if (rowIndex === 4) return phase2;
    if (rowIndex === 8) return phase3;
    return totalAll;
  };

  const handleChange = (e, rowIndex) => {
    const val = e.target.value.replace(",", ".");
    if (!/^(\d+([.]\d*)?|[.]\d+)?$/.test(val)) return;
    setNbrHeures(prev => {
      const next = [...prev];
      next[heureIndex(rowIndex)] = val;
      return next;
    });
  };

  const preventNonNumeric = (e) => {
    const allowed = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End", ".", ","];
    if (!allowed.includes(e.key) && !/^\d$/.test(e.key)) e.preventDefault();
  };

  const data1 = ROWS.map(row => ({ actType: row.label }));

  const columns1 = [
    {
      Header: "PHASE RÉALISATION",
      columns: [
        {
          Header: "ACTES TYPES",
          accessor: "actType",
          Cell: props => {
            const ri = props.row._index;
            return GROUP_INDICES.has(ri)
              ? <span className="cadrt-group-label">{props.value}</span>
              : <span className="cadrt-label">{props.value}</span>;
          },
        },
        {
          Header: "HEURES",
          accessor: "actType",
          id: "heures",
          width: 110,
          Cell: props => {
            const ri = props.row._index;
            if (GROUP_INDICES.has(ri)) {
              return <strong className="cadrt-total">{getGroupValue(ri)}</strong>;
            }
            return (
              <input
                className="cadrt-input"
                value={nbrHeures[heureIndex(ri)]}
                onChange={e => handleChange(e, ri)}
                onKeyDown={preventNonNumeric}
                inputMode="decimal"
                pattern="[0-9]*[.,]?[0-9]*"
              />
            );
          },
        },
      ],
    },
  ];

  const montants = [phase1 * tauxh, phase2 * tauxh, phase3 * tauxh];
  const totalHt = montants.reduce((t, v) => t + v, 0);

  const data2 = [
    { actType: "1. Préparation du chantier", prix: numberToFormat(montants[0]) },
    { actType: "2. Travaux", prix: numberToFormat(montants[1]) },
    { actType: "3. Réception des travaux", prix: numberToFormat(montants[2]) },
    { actType: "HONORAIRES :", prix: numberToFormat(totalHt) },
  ];

  const columns2 = [
    {
      Header: "PHASE RÉALISATION",
      columns: [
        {
          Header: "ACTES TYPES",
          accessor: "actType",
          Cell: props => {
            const isLast = props.row._index === 3;
            return isLast
              ? <span className="cadrt-group-label">{props.value}</span>
              : <span className="cadrt-label">{props.value}</span>;
          },
        },
        {
          Header: "PRIX",
          accessor: "prix",
          width: 150,
          Cell: props => {
            const isLast = props.row._index === 3;
            return isLast
              ? <strong className="cadrt-total">{props.value}</strong>
              : <span>{props.value}</span>;
          },
        },
      ],
    },
  ];

  return (
    <div className="contract-amendment-devisrea-table">
      <div className="cadrt-section-title">Répartition des heures</div>
      <ReactTable className="cadrt-table-hours" data={data1} columns={columns1} defaultPageSize={13} showPagination={false} />
      <div className="cadrt-section-title cadrt-section-title--second">Synthèse des honoraires</div>
      <ReactTable className="cadrt-table-summary" data={data2} columns={columns2} defaultPageSize={4} showPagination={false} />
    </div>
  );
};

export default ContractAmendmentDevisReaTable;
